/**
 *
 * @param {number} price
 * @returns {object} An object containing cents and dollars properties which are strings formatted.
 *
 * For example passing in 2 will return
 *      {
 *          cents: '00',
 *          dollars: '2'
 *      }
 */
module.exports = function formatPrice(price) {
    if (!price) {
        return {
            cents: '00',
            dollars: '0'
        };
    }

    price = price.toString();

    if (price.includes('.')) {
        const parts = price.split('.');
        if (parts[1].length === 1) {
            parts[1] += '0';
        }

        return {
            cents: parts[1],
            dollars: parts[0]
        };
    }

    return {
        cents: '00',
        dollars: price
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/utility/price-formatter.js
 **/